import { Grid, Paper } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { GRAY, WHITE } from "../colors";
import InquiryForm from "../containers/Forms/InquiryForm";
import ChatBox from "../containers/chatBox/ChatBox";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#D9D9D9",
  opacity:0.85,
  borderRadius: 10,
  padding: 10,
  textAlign: "center",
  height: "87vh",
  overflow:'auto',
  padding: "20px 40px",
}));
const FrontOffice = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Container elevation={0}>
          <InquiryForm />
        </Container>
      </Grid>
      <Grid item xs={6}>
        <Container elevation={0}>
          <ChatBox />
        </Container>
      </Grid>
    </Grid>
  );
};

export default FrontOffice;
